import { NavigationTabs, type NavigationTabItem } from '@exam-management/components';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    label: 'Question Creation',
    value: 'question-creation',
    path: '/task-management/question-creation',
    requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
  },
  {
    label: 'Question Review',
    value: 'question-review',
    path: '/task-management/question-review',
    requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_REVIEW.VIEW],
  },
  {
    label: 'QSet Review',
    value: 'review-qset',
    path: '/task-management/qset-review',
    requiredPermission: [APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW],
  },
];

export default function TaskManagementNavigationTabs() {
  const { permissions } = usePermission();
  const tabList = useMemo(
    () =>
      TAB_ITEMS.filter((tab) => {
        return tab?.requiredPermission?.every((permission) => {
          return permissions.includes(permission);
        });
      }),
    [permissions, TAB_ITEMS],
  );
  return <NavigationTabs items={tabList} />;
}
